import api from '@anm/api';
import StorageErrorModal from '@anm/components/StorageErrorModal';
import checkIsStorageError from '@anm/helpers/checkIsStorageError';
import { useCallback, useState } from 'react';

const useStorageCheck = () => {
  const [isStorageError, setIsStorageError] = useState(false);

  const checkStorage = useCallback(async (uploadedSize: number) => {
    const storageStats = await api().user.getUserStorageStats();
    const isError = checkIsStorageError({ storageStats, uploadedSize });

    isError && setIsStorageError(true);

    return isError;
  }, []);

  const renderStorageModal = () =>
    isStorageError ? <StorageErrorModal actionType="upload" onClose={() => setIsStorageError(false)} /> : null;

  return [checkStorage, renderStorageModal] as const;
};

export default useStorageCheck;
